// extracted by mini-css-extract-plugin
export var box = "box-module--box--85890";